module.exports = __webpack_public_path__ + "static/img/keduo.1a42a931.png";